import React from 'react';
import { Bot } from 'lucide-react';
import type { Meeting } from '../../types';
import { BOT_TONE_CLASS, botStatusLabel } from './botStatus';

export const BotStatusBadge: React.FC<{ bot: NonNullable<Meeting['bot']> }> = ({ bot }) => {
  const { label, tone } = botStatusLabel(bot);
  return (
    <span
      title={bot.error || label}
      className={`inline-flex items-center gap-1 shrink-0 px-2 py-0.5 rounded-full border text-[11px] font-semibold ${BOT_TONE_CLASS[tone]}`}
    >
      <Bot className={`w-3 h-3 ${tone === 'live' ? 'animate-pulse' : ''}`} />
      {label}
    </span>
  );
};
